module.exports = __webpack_public_path__ + "img/60-l.e505f3ff.png";